import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import EmptyState from './empty_state';
import View from './view';

import './styles.scss';

export function ListingTab({ deal }) {

  return (
    <div className="d-flex flex-column gap-3">
      <h5 className="py-3">Listing</h5>
      {!deal.listing && !deal.project && <EmptyState />}
      {deal.listing && <View />}
    </div>
  );
}

ListingTab.propTypes = {
  deal: PropTypes.shape({
    listing: PropTypes.object,
    project: PropTypes.object
  }).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(ListingTab);
